import React, { useContext } from 'react';
import { LanguageContext } from 'status/context';

const useLanguage = () => useContext(LanguageContext);

export default useLanguage;
